// modal.js
import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import '../css/Modal.css';
import axios from 'axios';
import { HotTable, HotColumn } from '@handsontable/react';
import { registerAllModules } from 'handsontable/registry';
import styleHs from '../css/Hs.module.css';
import reloadToken from '../helper/reloadtoken';
import { apiConfig } from '../helper/apiConfig';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const notify_cant_update_br_cont = (message, time = 800) => {
    toast.error(<div dangerouslySetInnerHTML={{ __html: message }} />, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: time,
    });
  };
  
  const notify_update_br_cont = (message, time = 2000) => {
    toast.success(<div dangerouslySetInnerHTML={{ __html: message }} />, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: time,
    });
  };

const Modal_doc_perusahaan = ({ modalVisible, toggleModal, data }) => {
    var title_document = ""
    const hostfile = process.env.REACT_APP_API_HOST_UPLOAD;
    const mainhost = process.env.REACT_APP_API_HOST_MASTER;
    var API_SHOW_FILE = hostfile + "PerusahaanFileDoc"
    var API_COMMENT = hostfile + "updatecomment"


    if (data.action == 'doc'){
        title_document = "Document"

    } else if (data.action == 'legal'){
        title_document = "Legal"
    }

    const [role, setRole] = useState("");
    const hotRef = useRef(null);
    const isMounted = useRef(true);
    const [hotInstance, setHotInstance] = useState(null);
    const [token, setToken] = useState(null);
    const [newRowValue, setNewRowValue] = useState('');
    const [colHeaders, setColHeaders] = useState([]);
    const [nama_pt, setNamaPt] = useState('')
    var data_all = [];

    const [modalIsOpen, setModalIsOpen] = useState(false);

    const openModal = () => {
        setModalIsOpen(true);
    };

    useEffect(() => {
        const role = localStorage.getItem('role');
        setRole(role);
        // Call openModal when modalVisible prop is true
        if (modalVisible) {
            openModal();
        }
    }, );
    
    const fetchData = async () => {
        try {

        const token = localStorage.getItem('token');
            if (hotRef.current && token && isMounted.current) {
                const hot = hotRef.current.hotInstance;
                setHotInstance(hot);
                const res = await loadData(token, data.id);
                setDataForTable(res);
            }
        } catch (error) {
            //console.error("Error fetching data:", error);
        }
    };

    function setDataForTable(res){
        if (res && Array.isArray(res.data.data)) {
            if (hotRef.current.hotInstance) {
                setTimeout(() => {
                    hotRef.current.hotInstance.loadData(res.data.data);
                    initializeForSearchColumn();
                    updateNamaPt(res.data.pt)      
                }, 500);

            } else {
                console.error("Hot instance is null or undefined");
            }
        } else {
            updateNamaPt(res.data.pt)
            console.error("Invalid data format or data is missing:", res);
        }
    }

    useEffect(() => {
        if (modalVisible) {
            document.body.classList.add('active-modal');
            fetchData();
        } else {
            document.body.classList.remove('active-modal');
        }
    }, [modalVisible]);

    const updateNamaPt = (data) => {
        setNamaPt(data);
      };

    const isDataEmpty = !data || !data.nama;


    const closeModal = () => {
        setModalIsOpen(false);
        toggleModal(); // Call the toggleModal function to close the modal
        if (role !== 'TIMKONSEP') {
           // window.location.reload();
        }
    };

    const loadData = async (token, id) => {
        try {
            const config = apiConfig(token);
            const formData = new FormData();
            formData.append("id", id);
            formData.append("type", data.action);

            const response = await axios.post(`${API_SHOW_FILE}`, formData , config);
            return response;
        } catch (error) {
            console.error('Error fetching column names:', error);
            return [];
        }
    };

    const handleAfterChange = async (changes, source) => {
        const token = localStorage.getItem('token');
        const config = apiConfig(token);
        if (source === 'edit') {
            let old_data = changes[0][2];
            let new_data = changes[0][3];
            if (old_data != new_data) {
                setTimeout(async function () {
                    const rowIndex = changes[0][0];
                    const id = data.id;
                    const datapost = {
                        "id":id,
                        "old": old_data,
                        "msg": hotInstance.getDataAtCell(rowIndex, 3),
                        "col": hotInstance.getDataAtCell(rowIndex, 4),
                        "tipe": hotInstance.getDataAtCell(rowIndex, 5),
                    };
                    try {
                        const response = await axios.post(`${API_COMMENT}`, datapost, config);
                        if (response.data.status === 'success') {
                            notify_update_br_cont(response.data.message)
                        } else {
                            const message = response.data.message;
                            console.log('Error:', message);
                        }
                    } catch (error) {
                        console.error('Error:', error);
                    }
                }, 100);
            }
        }
    };

    const handleAfterRemoveRow = async (index, amount, physicalRows, [source]) => {
    };

    const initializeForSearchColumn = () => {
        const debounceFn = (colIndex, event) => {
            const filtersPlugin = hotInstance.getPlugin('filters');
            filtersPlugin.removeConditions(colIndex);
            filtersPlugin.addCondition(colIndex, 'contains', [event.target.value]);
            filtersPlugin.filter();
        };

        const addEventListeners = (input, colIndex) => {
            input.addEventListener('keydown', (event) => {
                debounceFn(colIndex, event);
            });
        };

        const addInput = (col, TH) => {
            if (typeof col !== 'number') {
                return col;
            }

            if (col >= 0 && TH.childElementCount < 2 && col == 1) {
                TH.appendChild(getInitializedElements(col));
            }
        };

        const getInitializedElements = (colIndex) => {
            const div = document.createElement('div');
            const input = document.createElement('input');
            addEventListeners(input, colIndex);
            div.appendChild(input);
            return div;
        };

        const doNotSelectColumn = (event, coords) => {
            if (coords.row === -1 && event.target.nodeName === 'INPUT') {
                event.stopImmediatePropagation();
                hotInstance.deselectCell();
            }
        };
        try {
            hotInstance.updateSettings({
                afterGetColHeader: addInput,
                beforeOnCellMouseDown: doNotSelectColumn,
            });
        } catch (error) {
            //console.error('Error updating settings:', error);
        }
    }

    const columns = [
        { type: 'text', title: 'ID', align: 'center' },
        { type: 'text', title: '<b>Nama File</b>', editor: false, align: 'center' },
        { type: 'text', title: '<b>Upload</b>', editor: false, className: 'htCenter', renderer: 'html' },
        { type: 'text', title: '<b>Catatan</b>', className: 'htCenter' },
        { type: 'text', title: '<b>name column</b>', className: 'htCenter' },
        { type: 'text', title: '<b>tipe column</b>', className: 'htCenter' },
        { type: 'text', title: '<b>Download</b>', editor: false, className: 'htCenter', renderer: 'html' },
        { type: 'text', title: '<b>Hapus</b>', editor: false, className: 'htCenter', renderer: 'html' },
    ];

    const customRenderer = (instance, td, row, col, prop, value, cellProperties) => {
        if (typeof value === 'string') {
            td.innerHTML = value;
        }
    };

    return createPortal(
        modalVisible ? (
            <div className="modal" >
                <div onClick={closeModal} className="overlay"></div>
                <div className="modal-content-detail">
                    <table border={0} width={'100%'}>
                        <thead>
                        </thead>
                        <tbody>
                            <tr>
                                <td align='left'>
                                    {isDataEmpty ? (<p>Error, data is empty</p>) : (<div>
                                        <h6>Data File {title_document}</h6>
                                        <p style={{ marginTop: '-5px' }}>Upload sesuaikan dengan nama list file</p>
                                    </div>)}
                                </td>
                                <td align='right'>
                                    {isDataEmpty ? (<p>Error, data is empty</p>) : (<div>
                                        <h6 className='text_pt'>{nama_pt}</h6>
                                    </div>)}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div>
                        <HotTable
                            ref={hotRef}
                            columns={columns}
                            settings={{
                                afterChange: handleAfterChange,
                                beforeRemoveRow: handleAfterRemoveRow
                            }}
                            //data={data_all}
                            renderer={customRenderer}
                            contextMenu={true}
                            rowHeaders={true}
                            filters={true}
                            dropdownMenu={false}
                            outsideClickDeselects={false}
                            allowInsertColumn={true}
                            rowHeights={25}
                            autoRowSize={false}
                            manualColumnResize={true}
                            // fixedColumnsStart={5}
                            height={420}
                            width={805}
                            colHeaders={colHeaders}
                            colWidths={[0, 200, 250, 175, 70, 150, 75, 50 ]}
                            licenseKey="non-commercial-and-evaluation"
                            hiddenColumns={{
                                copyPasteEnabled: true,
                                indicators: false,
                                columns: [0, 4, 5]
                            }}
                        >
                            {colHeaders.map((colName, index) => (
                                <HotColumn key={index} renderer={"html"} editor={false} />
                            ))}
                        </HotTable>
                    </div>
                    <p>
                        {/* Your modal content */}
                    </p>
                    {/* <button className="btn_close-modal btn_upload" onClick={uploadModal}>
                        Upload
                    </button>
                    <button className="btn_close-modal btn_download" onClick={downloadModal}>
                        Download
                    </button> */}
                    <button className="btn_close-modal btn_close" onClick={closeModal}>
                        Close
                    </button>
                </div>
            </div>
        ) : null,
        document.body
    );
};

export default Modal_doc_perusahaan;